const demoUser = [];
const demoSMTP = [];
const salesUser = [];
const adminUser = {};
const manageCategory = [];
const manageSubCategory = [];
const manageLocation = [];
const manageFare = [];
const manageCancelReasons = [];

export {
    demoUser, adminUser, salesUser, demoSMTP, manageCategory, manageSubCategory, manageLocation, manageFare, manageCancelReasons
}